import React, { useState } from "react";

import { Error } from "@mui/icons-material";
import { Box, Grid, TextField, Typography, useTheme } from "@mui/material";

import ConfirmDialog from "components/shared/confirm-dialog";

interface CopySSOConnectionProps {
  handle: (
    originOrgID: string,
    originOrgName: string,
    targetOrgName: string
  ) => void;
  openCopySSOConnectionDialog: boolean;
  setOpenCopySSOConnectionDialog: (open: boolean) => void;
}

const CopySSOConnection = ({
  handle,
  openCopySSOConnectionDialog,
  setOpenCopySSOConnectionDialog,
}: CopySSOConnectionProps) => {
  const theme = useTheme();

  const [originOrgName, setOriginOrgName] = useState("");
  const [originOrgID, setOriginOrgID] = useState("");
  const [targetOrgName, setTargetOrgName] = useState("");

  return (
    <>
      <ConfirmDialog
        title="Copy SSO Connection"
        open={openCopySSOConnectionDialog}
        setOpen={setOpenCopySSOConnectionDialog}
        onConfirm={() => {
          handle(originOrgID, originOrgName, targetOrgName);
          setOpenCopySSOConnectionDialog(false);
        }}
        disabled={!originOrgID || !originOrgName || !targetOrgName}
        cancelBtnLabel="Cancel"
        confirmBtnLabel="Copy"
      >
        <Grid container direction="row" spacing={1} style={{ minWidth: 350 }}>
          <Grid item xs={12} container direction="column">
            <Box
              bgcolor={theme.palette.warning.main}
              borderRadius="5px"
              border={1}
              borderColor={theme.palette.secondary.main}
              marginBottom={3}
            >
              <Grid container alignItems="center">
                <Grid item xs={2} container justifyContent="center">
                  <Error fontSize="large" />
                </Grid>
                <Grid item xs={10} style={{ paddingRight: "20px" }}>
                  <p>
                    You are about to copy an SSO Connection from another
                    Organisation.
                  </p>
                  <p>
                    Deleting the original connection will result in all
                    organisation connections being destroyed. Be sure that you
                    copying from the correct organisation.
                  </p>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box>
              <Typography variant="body1">
                Type the ID & Name of the organisation you are copying from.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="originOrgID-input"
              label="Origin Organisation ID"
              value={originOrgID}
              onChange={(e) => {
                setOriginOrgID(e.target.value);
              }}
              variant="outlined"
              size="small"
              fullWidth
              inputProps={{
                "data-anchor": "originOrgID-input",
                "data-testid": "originOrgID-input",
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="originOrgName-input"
              label="Origin Organisation Name"
              value={originOrgName}
              onChange={(e) => {
                setOriginOrgName(e.target.value);
              }}
              variant="outlined"
              size="small"
              fullWidth
              inputProps={{
                "data-anchor": "originOrgName-input",
                "data-testid": "originOrgName-input",
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Box>
              <Typography variant="body1">
                Type the name of origanisation you are copying to (this
                organisation).
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="targetOrgName-input"
              label="Target Organisation Name"
              value={targetOrgName}
              onChange={(e) => {
                setTargetOrgName(e.target.value);
              }}
              variant="outlined"
              size="small"
              fullWidth
              inputProps={{
                "data-anchor": "targetOrgName-input",
                "data-testid": "targetOrgName-input",
              }}
            />
          </Grid>
        </Grid>
      </ConfirmDialog>
    </>
  );
};

export default CopySSOConnection;
